import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {RedactorUtils} from "../../core/RedactorUtils";
import {Schema} from "@/common/Schema";


export class TriggerTalk extends TriggerBase {

    constructor() {
        super(TriggerKind.TALK);
        this._talkUID = null;
    }

    get talkUID() {
        return this._talkUID;
    }

    set talkUID(value) {
        this._talkUID = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!this.talkUID || !RedactorUtils.getTalk(this.talkUID)) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerTalk());
        } else if (target instanceof TriggerTalk) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerTalkScope extends TriggerScope {
    static _values = [
        new TriggerTalkScope(1, "AVAILABLE"),
        new TriggerTalkScope(2, "ACTIVE"),
        new TriggerTalkScope(3, "CLOSED")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerTalkScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerTalkScope());
        } else if (target instanceof TriggerTalkScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerTalk, {
    _scope: alias("scope", TriggerTalkScope.schema()),
    _talkUID: alias("talk_uid", Schema.primitive())
});
